import {createAction, props} from '@ngrx/store';
import {EkranKoncowyActionsType} from './ekran-koncowy-actions-type';

export const kliknietoDodanjDokumenty = createAction(EkranKoncowyActionsType.KLIKNIETO_DODAJ_DOKUMENTY,
props<{correlationId: string}>());
